import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalMentions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#2D9A68] hover:text-[#237852] mb-6 transition-colors"
          >
            <ArrowLeft size={20} />
            Retour à l'accueil
          </Link>

          <h1 className="text-4xl font-bold text-gray-900 mb-8">Mentions Légales</h1>

          <div className="space-y-8 text-gray-700">
            {/* Éditeur du site */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
              <p className="mb-2">
                <strong>Raison sociale :</strong> Climatpac 81
              </p>
              <p className="mb-2">
                <strong>Siège social :</strong> Tarn (81)
              </p>
              <p className="mb-2">
                <strong>Téléphone :</strong> <a href="tel:0188617508" className="text-[#2D9A68] hover:underline">01 88 61 75 08</a>
              </p>
              <p className="mb-2">
                <strong>Email :</strong> <a href="mailto:contact@climatpac81.fr" className="text-[#2D9A68] hover:underline">contact@climatpac81.fr</a>
              </p>
              <p className="mb-2">
                <strong>Forme juridique :</strong> [À compléter]
              </p>
              <p className="mb-2">
                <strong>Capital social :</strong> [À compléter]
              </p>
              <p className="mb-2">
                <strong>Numéro SIRET :</strong> [À compléter]
              </p>
              <p className="mb-2">
                <strong>Numéro TVA intracommunautaire :</strong> [À compléter]
              </p>
            </section>

            {/* Directeur de publication */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Directeur de publication</h2>
              <p>[Nom du directeur de publication à compléter]</p>
            </section>

            {/* Hébergement */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Hébergement du site</h2>
              <p className="mb-2">
                <strong>Hébergeur :</strong> [Nom de l'hébergeur]
              </p>
              <p className="mb-2">
                <strong>Adresse :</strong> [Adresse de l'hébergeur]
              </p>
              <p className="mb-2">
                <strong>Téléphone :</strong> [Téléphone de l'hébergeur]
              </p>
            </section>

            {/* Certifications */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Certifications professionnelles</h2>
              <p className="mb-2">Climatpac 81 est certifié :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>QualiPAC</strong> - Reconnu Garant de l'Environnement</li>
                <li><strong>Qualibat</strong> - Qualification professionnelle du bâtiment</li>
                <li><strong>QualiPAC</strong> - Qualification pompes à chaleur</li>
              </ul>
              <p className="mt-4">
                Ces certifications permettent à nos clients de bénéficier des aides de l'État (MaPrimeRénov', CEE).
              </p>
            </section>

            {/* Assurances */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Assurances</h2>
              <p className="mb-2">
                <strong>Garantie décennale :</strong> [Nom de l'assureur et numéro de contrat]
              </p>
              <p className="mb-2">
                <strong>Responsabilité civile professionnelle :</strong> [Nom de l'assureur et numéro de contrat]
              </p>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Propriété intellectuelle</h2>
              <p className="mb-4">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
                Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique ou autre quel qu'il soit est formellement interdite
                sauf autorisation expresse du directeur de la publication.
              </p>
            </section>

            {/* Protection des données */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Protection des données personnelles</h2>
              <p className="mb-4">
                Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD),
                vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Pour exercer ces droits, vous pouvez nous contacter :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Par email : <a href="mailto:contact@climatpac81.fr" className="text-[#2D9A68] hover:underline">contact@climatpac81.fr</a></li>
                <li>Par téléphone : <a href="tel:0188617508" className="text-[#2D9A68] hover:underline">01 88 61 75 08</a></li>
              </ul>
              <p className="mt-4">
                Pour plus d'informations, consultez notre <Link to="/politique-confidentialite" className="text-[#2D9A68] hover:underline font-semibold">Politique de confidentialité</Link>.
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookies</h2>
              <p className="mb-4">
                Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visites.
              </p>
              <p>
                Vous pouvez vous opposer à l'enregistrement de cookies en configurant votre navigateur.
              </p>
            </section>

            {/* Liens hypertextes */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Liens hypertextes</h2>
              <p>
                Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres ressources présentes sur le réseau Internet
                ne sauraient engager la responsabilité de Climatpac 81.
              </p>
            </section>

            {/* Litiges */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Litiges</h2>
              <p>
                Les présentes conditions sont régies par les lois françaises et toute contestation ou litiges qui pourraient naître de l'interprétation
                ou de l'exécution de celles-ci seront de la compétence exclusive des tribunaux français.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t text-center text-gray-500 text-sm">
            <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalMentions;
